import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal } from 'react-overlays';
import _ from 'lodash';
import anime from 'animejs';
import dataModel from '../../../models/DataModel';
import PageStateDAO from '../../../dao/PageStateDAO';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import { PageNames } from '../../../constants/ReduxConstants';
import BaseComponent from '../../../baseClasses/BaseComponent';
import ProjectHeader from '../../TasksContainer/ProjectHeader';
import DashboardProjectCard from '../../../components/DashboardProjectCard';
import BuildDetailCard from './BuildDetailCard';
import NewBuildCard from './NewBuildCard';
import ExpandableSection from '../../../components/ExpandableSectionDocuments';
import MultiFileUploader from '../../../components/MultiFileUploader';
import DocumentsList from '../../../components/TaskCRUD/DocumentsList';
import CheckBox from '../../../components/CheckBox';
import DocumentsIcon from '../../../components/Iconoclast/DocumentsIcon';
import QuickerAssignPopup from '../../../components/QuickerAssignPopup';
import QuickerAssignErrorPopup from '../../../components/QuickerAssignErrorPopup';
import animator from '../../../helpers/animator';
import { slide_down, slide_up, slide_in, slide_out } from '../../../helpers/animation_types.js';
import styles from '../../../assets/styles/globals.scss';
import ProjectTimeline from './ProjectTimeline';
import DataSource from '../../../dao/DataSource/DataSource';
import LoadingDots from '../../../components/LoadingDots';
import './ProjectHierarchy.scss';

import { build_card } from '../../../dao/BuildsDAO';
import AssignmentPullout from '../AssignmentPullout';

var inoutSpeed = 500;
var updownSpeed = 500;

const shallowUserDescriptor = {
  additionalFields: ['profile_image'], 
  role: { }, 
  companies: { }, 
};
const deepUserDescriptor = {
  additionalFields: ['profile_image'], 
  role: { }, 
  companies: { }, 
  company_vendor_users: { 
    vendor_user: { additionalFields: ['profile_image'], role: { }, companies: { } }, 
  }, 
};
const projectDescriptor = {
  project: {
    additionalFields: ['has_alerts', 'has_unread_alerts', 'has_delays'],
    builds: {
      user_build_assignments: { user: shallowUserDescriptor },
      build_owners: { companies: {} },
      builds: {},
    },
    project_manager: {},
    project_users: { user: shallowUserDescriptor },
    project_contacts: { user: {} },
    location: { market: {}, location_users: { user: {} } },
    users: deepUserDescriptor,
    company: {},
    unique_documents: {},
    reference_documents: {},
    custom_project_settings: {},
  },
};

export class ProjectHierarchy extends BaseComponent {

  constructor(props) {
    super(props);

    this.animator = new animator();

    this.createExpandedProjectChildren = this.createExpandedProjectChildren.bind(this);
    this.createChildren = this.createChildren.bind(this);

    this.needsSetData = true;
    this.hasAnimated = false;
    this.mapInitialized = false;
    this.bulkAssignBuilds = [];

    this.state = {
      project: null,
      projectLoadPending: false,
      projectLoadError: false,
      selectedBuild: null,
      scrollHeightDiffFromHeader: 0,
      currentFilterOption: null,
      displayHeight: 0,
      isAssignAllBuildsSelected: false,
      bulkAssignBuildCount: 0,
      projectTimelineExpanded: false,
      preprojectTimelineExpanded: false,
    };

    this.updateBuildAssignments = this.updateBuildAssignments.bind(this);
    this.uploadProjectDocument = this.uploadProjectDocument.bind(this);
    this.deleteProjectDocument = this.deleteProjectDocument.bind(this);
    this.deleteReferenceDocument = this.deleteReferenceDocument.bind(this);
    this.createExpandedProjectChildren = this.createExpandedProjectChildren.bind(this);
    this.handleProjectFavoriteUpdated = this.handleProjectFavoriteUpdated.bind(this);
  }

  updateDimensions() {
    this.setState({ toggleRender: !this.state.toggleRender });
  }

  handleProjectRetrieval(project, action, acData, fetchedData) {
    if (action == 'prefetch') {
      if ((!project.builds || project.builds.length == 0) && project.builds_count > 0) {
        for (let i = 0; i < project.builds_count - 1; i++) {
          project.root_build.builds.push({ id: i * -1, inProgress: true, parent: project, ancestry: project.root_build_id });
        }
      }
      this.setState({ project, projectLoadPending: false });
      this.refreshStuff(project);
    }
    else {
      if (acData && acData.bulk_assign) {
        this.hasForceScrolled = false;
        this.setState({ fetchedData });
      }
      else {
        if (fetchedData && fetchedData.builds.length != project.builds.length) {
          this.dontScroll = true;
          this.projectDataSource.get();
        }
        if (fetchedData && fetchedData.unique_documents.length != project.unique_documents.length) {
          return;
        }
        else if (acData && acData.type == 'updateProject' && acData.sub_type == 'newBuild') {
          this.dontScroll = true;
          this.projectDataSource.get();
        }
        else {
          this.setState({ project, projectLoadPending: false });
          this.refreshStuff(project);
        }
      }
    }
    if (project) {
      const projectChildrenDisplay = this.createExpandedProjectChildren(project);
      this.setState({ projectChildrenDisplay });
      if (this.scroller) {
        if (!this.dontScroll && !this.hasForceScrolled) {
          // this.scroller.scrollTop = 0
          //setTimeout(() => {
          //  this.hasForceScrolled = true
          //}, 500)
        }
        else {
          this.dontScroll = false;
        }
      }
    }
  }

  componentDidMount() {
    const pageState = PageStateDAO.findPageState(PageNames.PROJECTS_CONTAINER);

    this.setState({ mapExpanded: pageState ? pageState.mapExpanded : false });
    
    const currentRole = this.props.currentUser ? this.props.currentUser.role : null;

    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    window.addEventListener('resize', this.updateDimensions.bind(this));
    window.addEventListener('projectFavoriteUpdated', this.handleProjectFavoriteUpdated);
    super.componentDidMount();
    this.setDocumentsPermissions();

    if (this.props.params.project_id) {
      const project_id = +this.props.params.project_id;
      this.handleInitializeDataSource(project_id, this.props.params.user_id ? + this.props.params.user_id: null);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('projectFavoriteUpdated', this.handleProjectFavoriteUpdated);
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
  }

  handleProjectFavoriteUpdated(e) {
    const projectId = e.detail && e.detail.projectId;
    if (projectId == null || !this.state.project || this.state.project.id != projectId) {
      return;
    }
    const project = dataModel.projectsDAO.findItem(projectId);
    if (project) {
      const mappedProject = dataModel.projectsDAO.mapToReturn(project, { recordDescriptor: projectDescriptor });
      this.setState({ project: mappedProject });
      this.refreshStuff(mappedProject);
      const projectChildrenDisplay = this.createExpandedProjectChildren(mappedProject);
      this.setState({ projectChildrenDisplay });
    }
  }

  handleInitializeDataSource(project_id, user_id) {
    this.setState({ projectLoadPending: true, projectLoadError: false, project: null });
    if (this.projectDataSource) {
      this.projectDataSource.release();
    }
    this.projectDataSource = new DataSource('Project', project_id, projectDescriptor, this.handleProjectRetrieval);
    // A missing/inaccessible project rejects the get(); without this catch the success
    // callback never fires and the view is stuck on the loading spinner forever.
    this.projectDataSource.get().catch(() => {
      if (+this.props.params.project_id === project_id) {
        this.setState({ projectLoadPending: false, projectLoadError: true });
      }
    });

    let timeLineExpanded = false;
    let historyState = this.props.history.getState();
    if (historyState && historyState.projectHierachyState && historyState.projectHierachyState.projectTimelineState) {
      if (historyState.projectHierachyState.projectTimelineState[project_id] &&
        historyState.projectHierachyState.projectTimelineState[project_id].expanded) {
        timeLineExpanded = true;
      }
    }
    this.setState({ projectTimelineExpanded: timeLineExpanded, preprojectTimelineExpanded: timeLineExpanded, internalprojectTimelineExpanded: timeLineExpanded });
    this.setDocumentsPermissions();
  }

  componentDidUpdate(prevProps) {
    if (this.scrollToRight && this.scroller) {
      this.scroller.scrollLeft = this.displayWidth;
      this.scrollToRight = false;
    }
    if (this.props.params.project_id) {
      const project_id = +this.props.params.project_id;
      if (this.state.project && project_id != this.state.project.id) {
        this.handleInitializeDataSource(project_id);
      }
    }
    
    if (this.props.quickAssignments != prevProps.quickAssignments || (this.props.quickAssignments && !this.availableBuildsForBulkAssign)) {
      if (this.props.quickAssignments){
        this.createSelectableBuilds();
      }
      else {
        this.availableBuildsForBulkAssign = [];
        this.bulkAssignBuilds = [];
        this.setState({
          isAssignAllBuildsSelected: false,
          bulkAssignBuildCount: 0,
        }, () => {
          const projectChildrenDisplay = this.createExpandedProjectChildren(this.state.project);
          this.setState({ projectChildrenDisplay });
          // this.scroller.scrollTop = 0
        });
      }
    }
  }

  createSelectableBuilds() {
    const { quickAssignments } = this.props;
    if (quickAssignments && this.state.project) {
      if (quickAssignments['build-owner']) {
        this.availableBuildsForBulkAssign = this.state.project.builds.filter(build => {
          return build;
        });
      }
      else if (quickAssignments['build-notify']) {
        this.availableBuildsForBulkAssign = this.state.project.builds.filter(build => {
          return build;
        });
      }
      const projectChildrenDisplay = this.createExpandedProjectChildren(this.state.project);
      this.setState({ projectChildrenDisplay });
      // this.scroller.scrollTop = 0
    }
  }

  setDocumentsPermissions() {
    const { currentUser, currentCompany } = this.props;
    const currentRoleName = currentUser.role ? currentUser.role.name : null;
    const userIsVendor = (currentUser.companies[0].id != currentCompany.id);
    
    this.userCanModifyDocuments = (!userIsVendor || currentRoleName == 'super_user'); 
    const userCanViewDocuments = (userIsVendor || currentRoleName == 'super_user' || currentRoleName == 'editor' || currentRoleName == 'admin');
    if (this.state.userCanViewDocuments != userCanViewDocuments) {
      this.setState({ userCanViewDocuments });
    }
  }

  uploadProjectDocument(file) {
    const document = {
      attachment: file,
      name: file.name,
    };
    this.analyticsLogger.logUniqueDocumentUpload();
    this.projectDataSource.performAction('addUniqueDocument', this.state.project, null, document, { recordDescriptor: projectDescriptor });
  }

  deleteProjectDocument(docId) {
    const { project } = this.state;
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      width: 320,
      height: 184,
      message: 'Are you sure you want to delete this Document?',
      cancelButtonText: 'No',
      okButtonText: 'Yes',
      handleOwnerOk: () => {
        this.analyticsLogger.logUniqueDocumentDelete();
        this.projectDataSource.performAction('removeUniqueDocument', project, docId);
      },
    });
  }

  deleteReferenceDocument(docId) {
    const { project } = this.state;
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      width: 320,
      height: 184,
      message: 'Are you sure you want to delete this Reference Document?',
      cancelButtonText: 'No',
      okButtonText: 'Yes',
      handleOwnerOk: () => {
        this.analyticsLogger.logReferenceDocumentDelete();
        this.projectDataSource.performAction('removeReferenceDocument', project, docId);
      },
    });
  }

  handleEditBuild(build, editing) {
    if (build && this.projectMap && this.projectMap[build.id]) {
      this.projectMap[build.id].editing = editing;
      const projectChildrenDisplay = this.createExpandedProjectChildren(this.state.project);
      this.setState({ projectChildrenDisplay });
    }
  }

  createProjectStateMap(project, items, parent) {
    if (items) {
      for (let j = 0; j < items.length; j++) {
        let item = items[j];
        if (!this.projectMap[item.id]) {
          this.mapInitialized = true;
          this.projectMap[item.id] = {
            expanded: false, animated: false, parent: parent, toggled: this.toggled,
          };
          if (!this.newMap && parent) {
            this.projectMap[parent.build ? parent.build.id : parent.id].expanded = true;
          }
        }
        else {
          this.projectMap[item.id].parent = parent;
          this.projectMap[item.id].toggled = this.toggled;
        }
        this.projectMap[item.id].id = item.id;
        this.projectMap[item.id].item = item;
        if (item.builds && item.builds.length > 0) {
          this.createProjectStateMap(project, item.builds, item);
        }
      }
    }
  }

  createPositionsInStateMap(items) {
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (this.projectMap[item.id]) {
        const itemElement = document.getElementById('build-card-' + item.id);
        if (itemElement) {
          let itemRect = itemElement.getBoundingClientRect();
          this.projectMap[item.id].x = itemRect.left;
          this.projectMap[item.id].y = itemRect.top + this.scroller.scrollTop;
          this.projectMap[item.id].width = itemRect.width;
          this.projectMap[item.id].height = itemRect.height;
        }
      }
      if (item.builds) {
        this.createPositionsInStateMap(item.builds);
      }
    }
  }

  refreshStuff(project) {
    if (project) {
      if (project.root_build.builds) {
        if (!this.projectMap) {
          this.projectMap = {};
          this.newMap = true;
        }
        this.toggled = !this.toggled;
        if (project.root_build_id) {
          if (!this.mapInitialized) {
            this.newMap = true;
          }
          this.projectMap[project.root_build_id] = {};
          this.createProjectStateMap(project, project.root_build.builds, null);
          this.projectMap[project.root_build_id].expanded = true;
          this.projectMap[project.root_build_id].toggled = this.toggled;
          for (let id in this.projectMap) {
            if (id) {
              if (this.projectMap[id].toggled != this.toggled) {
                delete this.projectMap[id];
              }
            }
          }
          this.newMap = false;
        }
        this.savedProject = project;
      }
      else {
        this.projectMap = {};
        this.newMap = true;
        if (project && project.root_build_id) {
          this.projectMap[project.root_build_id] = {};
          this.createProjectStateMap(project, project.root_build.builds, null);
          this.projectMap[project.root_build_id].expanded = true;
        }
      }
      this.setState({ project });
    }
  }

  collapseChildren(builds, animated) {
    if (builds) {
      let animationHorizontalGroup = [];
      let animationVerticalGroup = [];
      let groupAdded = false;
      let addAdded = false;

      for (var i = 0; i < builds.length; i++) {
        const build = builds[i];

        if (animated && this.projectMap[build.id] && this.projectMap[build.id].parent) {
          const parent = this.projectMap[build.id].parent;

          if (!addAdded) {
            addAdded = true;
            const addId = 'new-build-card-' + parent.id;

            let slideOutAni = this.animator.createAnimation(slide_out, addId, inoutSpeed, false, 25, -221);
            animationHorizontalGroup.push(slideOutAni);
            const element = document.getElementById(addId);
            if (element) {
              const itemTop = element.style.top;
              const intTop = parseInt(itemTop.replace('px', ''), 10);

              if (intTop > 0) {
                let vertId = 'vertical-connector-' + parent.id;
                let slideUpAni = this.animator.createAnimation(slide_up, addId, updownSpeed, false, intTop, 0, vertId);
                animationVerticalGroup.push(slideUpAni);
              }
              if (!groupAdded) {
                groupAdded = true;
                this.animator.addCollection(animationHorizontalGroup, true);
                this.animator.addCollection(animationVerticalGroup, true);
              }
            }
          }
          const id = 'build_' + build.id + '_' + (build.order ? build.order : '') + parent.id;

          let slideOutAni = this.animator.createAnimation(slide_out, id, inoutSpeed, false, 25, -221);
          animationHorizontalGroup.push(slideOutAni);
          const element = document.getElementById(id);
          if (element) {
            const itemTop = element.style.top;
            const intTop = parseInt(itemTop.replace('px', ''), 10);

            if (intTop > 0) {
              let vertId = 'vertical-connector-' + parent.id;
              let slideUpAni = this.animator.createAnimation(slide_up, id, updownSpeed, false, intTop, 0, vertId);
              animationVerticalGroup.push(slideUpAni);
            }
            if (!groupAdded) {
              groupAdded = true;
              this.animator.addCollection(animationHorizontalGroup, true);
              this.animator.addCollection(animationVerticalGroup, true);
            }
          }
        }
        if (this.projectMap[build.id].toExpand) {
          this.collapseChildren(build.builds, animated);
        }
        this.projectMap[build.id].toExpand = false;
        this.projectMap[build.id].expanded = false;
      }
    }
  }

  collapseSiblings(item, animated) {
    let parent = this.projectMap[item.id].parent;
    if (!parent) {
      parent = this.state.project;
    }
    let builds = null;
    if (parent.root_build_id) {
      builds = this.state.project.root_build.builds;
    }
    else {
      builds = parent.builds;
    }
    if (builds) {
      for (var i = 0; i < builds.length; i++) {
        const build = builds[i];
        if (build.id != item.id) {
          if (!this.projectMap[build.id]) {
            this.projectMap[build.id] = { expanded: false, animated: false, parent: parent, toggled: this.toggled };
          }
          else if (this.projectMap[build.id].toExpand) {
            this.collapseChildren(build.builds, animated);
          }
          this.projectMap[build.id].toExpand = false;
          this.projectMap[build.id].expanded = false;
        }
      }
      if (parent != this.state.project) {
        this.collapseSiblings(parent, animated);
      }
    }
  }

  findParentOfBuild(build, project) {
    // Traverse ancestry to find  build
    const ancestry = build.ancestry.split('/');
    let buildToSearch = project.root_build.builds[0];
    let buildIdToFind = ancestry.shift();
    while (ancestry.length) {
      buildIdToFind = ancestry.shift();
      // eslint-disable-next-line no-loop-func
      buildToSearch = buildToSearch.builds.find(build => build.id == +buildIdToFind); 
    }
    return buildToSearch;
  }

  handleBuildDeletion(deletedBuild) {
    const project = Object.assign({}, this.state.project);
    const deletedBuildsParent = this.findParentOfBuild(deletedBuild, project);
    const deletedBuildIndex = deletedBuildsParent.builds.findIndex(build => build.id == deletedBuild.id);
    if (deletedBuildIndex >= 0) {
      deletedBuildsParent.builds.splice(deletedBuildIndex, 1);
      this.setState(project);
    }
  }

  handleFindColumn(x) {
    for (let id in this.projectMap) {
      if (id) {
        const item = this.projectMap[id];
        if (item.width && x >= item.x && x <= (item.x + item.width)) {
          return x;
        }
      }
    }
  }

  handleFindDragTarget(y) {
    if (this.dragX) {
      const normalizedY = y + this.outerScroll.scrollTop;
      let firstInList = true;
      for (let i = 0; i < this.orderedDragList.length; i++) {
        let id = this.orderedDragList[i].id;
        if (id) {
          const item = this.projectMap[id];
          const element = document.getElementById('build-card-' + id);
          if (element) {
            const rect = element.getBoundingClientRect();
            if (firstInList && normalizedY < rect.top && normalizedY <= (rect.top + rect.height / 2)) {
              this.dragBefore = true;
              return item;
            }
            else if (normalizedY >= rect.top && normalizedY <= (rect.top + rect.height)) {
              this.dragBefore = false;
              return item;
            }
            firstInList = false;
          }
        }
      }
    }
  }

  handleCreateDragIndicator() {
    this.lineElement = document.createElement('div');
    this.lineElement.style.width = '256px';
    this.lineElement.style.height = '6px';
    this.lineElement.style.backgroundColor = '#a7a7a7';
    this.lineElement.style.position = 'absolute';
    this.lineElement.style.zIndex = 999;
    this.container.appendChild(this.lineElement);
  }

  handlePositionDragIndicator() {
    const containerRect = this.container.getBoundingClientRect();
    let top = (this.dragTarget.y - containerRect.top - this.scroller.scrollTop) + this.dragTarget.height - 10;
    if (this.dragBefore) {
      top = this.dragTarget.y - this.dragTarget.height - 8;
    }
    top += 20;
    this.lineElement.style.top = top + 'px';
    this.lineElement.style.left = (this.dragTarget.x - containerRect.left) + 'px';
  }

  handleDragging(build, x, y) {

    // Start in one column, and stay in that column
    if (!this.dragX) {
      this.orderedDragList = [];
      for (let id in this.projectMap) {
        if (id) {
          if (this.projectMap[id].item) {
            this.orderedDragList.push(this.projectMap[id]);
          }
        }
      }
      this.orderedDragList.sort((i1, i2) => {
        if (i1.item.order < i2.item.order) {
          return -1;
        }
        else if (i1.item.order > i2.item.order) {
          return 1;
        }
        else {
          return 0;
        }
      });
      this.createPositionsInStateMap(this.state.project.root_build.builds);
      this.dragX = this.handleFindColumn(x);
      this.dragTarget = this.handleFindDragTarget(y);
      this.handleCreateDragIndicator();
      if (this.dragTarget) {
        this.handlePositionDragIndicator();
      }
    }
    else {
      const newDragTarget = this.handleFindDragTarget(y);
      if ((newDragTarget && newDragTarget != this.dragTarget) || this.dragBefore) {
        this.dragTarget = newDragTarget;
        this.handlePositionDragIndicator();
      }
    }
    if (this.dragTarget) {
      const scrollerRect = this.scroller.getBoundingClientRect();
      if (y + 20 + this.dragTarget.height > scrollerRect.bottom) {
        this.scroller.scrollTop += (y + 20 + this.dragTarget.height) - scrollerRect.bottom;
      }
      else if (y < scrollerRect.top) {
        this.scroller.scrollTop -= Math.abs(y - scrollerRect.top);
      }
    }
  }

  handleDragFinished() {
    if (this.lineElement) {
      this.container.removeChild(this.lineElement);
    }
    delete this.dragX;
    delete this.lineElement;
    delete this.dragTarget;
  }

  orderBuilds(builds, afterBuild, insertedBuild, orderedBuilds) {
    let order = 1;
    if (!afterBuild) {
      insertedBuild.order = order++;
      orderedBuilds.push(insertedBuild);
      for (let i = 0; i < builds.length; i++) {
        const copyBuild = builds[i];
        if (copyBuild.id != insertedBuild.id) {
          copyBuild.order = order++;
          orderedBuilds.push(copyBuild);
        }
      }
    }
    else {
      for (let i = 0; i < builds.length; i++) {
        const copyBuild = builds[i];
        if (copyBuild.id != insertedBuild.id) {
          copyBuild.order = order++;
          orderedBuilds.push(copyBuild);
          if (copyBuild.id == afterBuild.id) {
            insertedBuild.order = order++;
            orderedBuilds.push(insertedBuild);
          }
        }
      }
    }
  }

  async handleDropping(orderedBuild, x, y) {
    if (this.dragTarget) {
      let afterBuild = this.dragBefore ? null : this.dragTarget.item;
      let reorderedBuilds = {};

      // make sure there are no duplicate orders

      let order = 1;
      for (let build of this.state.project.root_build.builds) {
        if (build.order != order) {
          build.order = order++;
          if (afterBuild && afterBuild.id == build.id) {
            afterBuild = build;
          }
          else if (build.id == orderedBuild.id) {
            orderedBuild = build;
          }
          reorderedBuilds[build.order] = build;
        }
        else {
          order++;
        }
      }

      let oldOrder = orderedBuild.order;
      let newOrder = !afterBuild ? 1 : afterBuild.order > oldOrder ? afterBuild.order : afterBuild.order + 1;

      let startOrder = oldOrder < newOrder ? oldOrder : newOrder;
      let endOrder = oldOrder > newOrder ? oldOrder : newOrder;
      let currentOrder = oldOrder < newOrder ? oldOrder : newOrder + 1;
      for (let build of this.state.project.root_build.builds) {
        let t = build;
        if (t.order >= startOrder && build.order <= endOrder && build.id != orderedBuild.id) {
          build.order = currentOrder++;
          reorderedBuilds[build.order] = build;
        }
      }

      orderedBuild.order = newOrder;
      reorderedBuilds[newOrder] = orderedBuild;

      let reorderedArray = [];
      for (var key in reorderedBuilds) {
        if (key) {
          let build = reorderedBuilds[key];
          reorderedArray.push(build);
        }
      }
      dataModel.buildsDAO.reorderBuilds(reorderedArray, this.state.project).then(reorderedParent => {
      });
    }
    this.handleDragFinished();
  }

  handleDragCancel() {
    this.handleDragFinished();
  }

  sortBuilds(builds) {
    builds.sort((t1, t2) => {
      if (t1.order && !t2.order) {
        return -1;
      }
      else if (!t1.order && t2.order) {
        return 1;
      }
      else if (t1.order && t2.order) {
        if (t1.order < t2.order) {
          return -1;
        }
        else if (t1.order > t2.order) {
          return 1;
        }
        else {
          return 0;
        }
      }
      else if (t1.id < t2.id) {
        return -1;
      }
      else if (t1.id > t2.id) {
        return 1;
      }
      else return 0;
    });
  }

  createChildren(project, parent, builds, left, top, animated) {
    if (builds) {

      // sort the builds
      this.sortBuilds(builds);
    }
    this.projectMap[parent.id ? parent.id : parent].expanded = true;
    
    let usedBuilds = builds ? builds : [];
    let verticalExpandedCardGroup = [];
    let animationHorizontalGroup = [];
    let animationVerticalGroup = [];
    let columnHeight = 0;
    let expandedBuild = null;
    let internalTop = 0;
    let expandedTop = 0;

    //*************************************************
    //
    //  Create the list of individual builds that will
    //  be in the column
    //
    //*************************************************
    let firstBuild = true;
    let numBuilds = usedBuilds.length;
    const buildList = usedBuilds.map((build) => {
      if (!build) {
        return null;
      }

      if (!this.projectMap[build.id]) {
        let parent = null;
        let parentId;
        if (build.ancestry) {
          if (Number.isInteger(build.ancestry)) {
            parentId = build.ancestry;
          }
          else {
            const anc = build.ancestry.split('/');
            parentId = +anc[anc.length - 1];
          }
          parent = this.projectMap[parentId].build;
        }
        this.projectMap[build.id] = {
          selected: false, expanded: false, childSelected: false, animated: false, parent: parent, toggled: this.toggled, build: build,
        };
      }
      let displayTop = internalTop;

      let buildHeight = 144;
      if (this.projectMap[build.id] && this.projectMap[build.id].editing) {
        buildHeight = 254;
      }
      internalTop += buildHeight + 34;
      this.detailHeight = Math.max(this.detailHeight, internalTop);
      if (this.projectMap[build.id] && this.projectMap[build.id].toExpand) {
        expandedBuild = build;
        expandedTop = displayTop;
      }

      const id = 'build_' + build.id + '_' + (build.order ? build.order : '') + (parent.id ? parent.id : parent);
      if (animated) {
        let slideInAni = this.animator.createAnimation(slide_in, id, inoutSpeed, true, -221, 25);

        animationHorizontalGroup.push(slideInAni);

        if (displayTop != 0) {
          let slideDownAni = this.animator.createAnimation(slide_down, id, updownSpeed, false, 0,
            displayTop, 'vertical-connector-' + (parent.id ? parent.id : parent));
          animationVerticalGroup.push(slideDownAni);
        }
        displayTop = 0;
      }

      let bulkAssignSelected = false;
      if (this.props.quickAssignments) {
        const foundBuild = this.bulkAssignBuilds.find(assignedBuild => assignedBuild.id == build.id);
        bulkAssignSelected = foundBuild ? true : false;
      }

      const connectorClass = firstBuild ? 'project-horizontal-connector' : 'project-half-horizontal-connector';
      firstBuild = false;
      columnHeight += buildHeight + 34;
      this.containerHeight = Math.max(this.containerHeight, columnHeight);

      return (
        <div id={id} key={id}
          className="class-detail-card"
          style={{ left: animated ? - 221 : 25, top: displayTop }}>
          <hr className={connectorClass} />
          <BuildDetailCard
            id={'build-card-' + build.id}
            left={0}
            top={0}
            buildId={build.id}
            project={project}
            handleBuildExpand={this.handleCardExpand}
            expanded={this.projectMap[build.id].toExpand}
            onDeleteBuild={this.handleBuildDeletion}
            selectBuild={this.props.quickAssignments ? this.handleBulkAssignBuildSelection : this.handleBuildSelection}
            handleDragging={this.handleDragging}
            handleDropping={this.handleDropping}
            handleDragCancel={this.handleDragCancel}
            selected={this.projectMap[build.id].selected}
            dragParentId={'project-and-build-card-container'}
            isDialog={true}
            handleEditBuild={this.handleEditBuild}
            updateBuildAssignments={this.updateBuildAssignments}
            quickAssignments={this.props.quickAssignments}
            bulkAssignSelected={bulkAssignSelected}
          />
        </div>
      );
    });

    let newCard;
    if (!expandedBuild && (this.props.permissions.canEditProject || this.props.permissions.canCreateBuild) && !project.archived_at) {
      const connectorClass = buildList.length > 0 ? 'project-half-horizontal-connector' : 'project-horizontal-connector';
      let id = 'new-build-card-' + (parent.id ? parent.id : parent);
      newCard = (
        <NewBuildCard
          id={id}
          key={id}
          connectorClass={connectorClass}
          left={animated ? -221 : 25}
          top={animated ? 0 : internalTop}
          type='build'
          width={256}
          height={141}
          handleCreate={this.handleCreateBuild}
          parent={parent}
          project={project}
        />
      );
      columnHeight += 154;
      numBuilds++;
      if (animated) {
        let slideInAni = this.animator.createAnimation(slide_in, id, inoutSpeed, true, -221, 25);

        animationHorizontalGroup.push(slideInAni);
        if (internalTop != 0) {
          let slideDownAni = this.animator.createAnimation(slide_down, id, updownSpeed, false, 0,
            internalTop, 'vertical-connector-' + (parent.id ? parent.id : parent));
          animationVerticalGroup.push(slideDownAni);
        }
      }
    }

    //*************************************************
    //
    // Add the expansion animations (out and down)
    //
    //*************************************************
    if (verticalExpandedCardGroup.length > 0) {
      this.animator.addCollection(verticalExpandedCardGroup, true);
    }
    if (animated) {
      this.animator.addCollection(animationVerticalGroup, false);
      this.animator.addCollection(animationHorizontalGroup, true);
    }
    //*************************************************
    //
    // Create the column that contains the builds
    //
    //*************************************************
    const minHeight = window.innerHeight - this.state.scrollHeightDiffFromHeader - 167;
    const style = { left: left - 25, top: top, height: columnHeight ? columnHeight + 75 : minHeight, width: 291 };
    this.displayWidth = left + 291 + 25;
    let connectorStyle = {};
    if (this.props.permissions.canEditProject) {
      connectorStyle = { top: 27, height: animated || numBuilds == 1 ? 0 : columnHeight - (!expandedBuild ? 154 : 177) };
    }
    else {
      connectorStyle = { top: 27, height: (animated || numBuilds == 1 ? 0 : (columnHeight - (!expandedBuild ? 177 : 180))) };
    }
    if (numBuilds <= 1) {
      connectorStyle = { display: 'none' };
    }
    if (this.props.quickAssignments) {
      // style.left = (style.left + 287)
      // style.top = (style.top + 131)
      connectorStyle.height -= (!expandedBuild ? 177 : 0);
    }
    const childNode =
      <div id={'column-' + (parent.id ? parent.id : parent)} className="child-column build-column" style={style}
        key={'column-' + (parent.id ? parent.id : parent)} >
        <hr id={'vertical-connector-' + (parent.id ? parent.id : parent)} className="vertical-connector" style={connectorStyle} />
        {buildList}
        { !this.props.quickAssignments && newCard }
      </div>;

    //************************************************* 
    //
    // Create the next column over if there is an  
    // expanded build in this column
    //
    //*************************************************
    let nodeArray = [childNode];
    if (expandedBuild) {
      const nextChildNode = this.createChildren(project, expandedBuild, expandedBuild.builds, left + 282,
        top + expandedTop, !this.projectMap[expandedBuild.id].expanded);
      if (nextChildNode != -1) {
        nodeArray.push(nextChildNode);
      }
    }

    //************************************************* 
    //
    // Animate the expansion if required
    //
    //*************************************************
    if (animated) {
      let _this = this;
      setTimeout(function() {
        _this.animator.processAnimationQueue(() => {
        });
      }, 10);
    }
    return nodeArray;

  }

  createExpandedProjectChildren(project) {
    if (!this.projectMap || !project || !this.projectMap[project.root_build_id]) {
      return null;
    }
    const left = 256 + 25;
    const top = 32;
    this.containerHeight = 0;
    if (this.props.permissions.canViewTask) {
      const projectChildren = this.createChildren(project, project.root_build_id, project.root_build.builds, left, top, false);
      this.dontAnimate = false;
      if (this.scroller && !this.state.projectChildrenDisplay) {
        // this.scroller.scrollTop = 0
      }
      return projectChildren;
    }
    else {
      return null;
    }
  }

  handlePopupClose() {
    this.setState({ userAssignmentPopup: null, companyAssignmentPopup: null });
  }

  handleBuildCardExpand(build, callback) {

    let selectedBuild = build;

    if (this.animator.animationLock) {
      return;
    }
    this.projectMap[build.id].toExpand = !this.projectMap[build.id].toExpand;

    if (!this.projectMap[build.id].toExpand) {
      this.collapseChildren(build.builds, true, this.animator);
    }
    else {
      this.scrollToRight = true;
      this.collapseSiblings(build, true, this.animator);
    }
    this.projectMap[build.id].selected = true;
    this.projectMap[build.id].expanded = false;
    this.projectMap[build.id].editing = false;

    if (this.animator.hasAnimations) {
      this.animator.processAnimationQueue(() => {
        if (callback) {
          callback();
        }
        if (this.scroller) {
          // this.scroller.scrollTop = 0
        }
        // Trigger the re-render by toggling the state
        this.setState({
          userAssignmentPopup: null, companyAssignmentPopup: null, selectedProject: null, selectedBuild: selectedBuild,
        });
        const projectChildrenDisplay = this.createExpandedProjectChildren(this.state.project);
        this.setState({ projectChildrenDisplay });
      });
    }
    else {
      if (this.scroller) {
        // this.scroller.scrollTop = 0
      }
      this.setState({
        userAssignmentPopup: null, companyAssignmentPopup: null, selectedProject: null, selectedBuild: selectedBuild,
      });
      const projectChildrenDisplay = this.createExpandedProjectChildren(this.state.project);
      this.setState({ projectChildrenDisplay });
    }
  }

  handleCardExpand(item, callback) {

    // Item is either a project or a build

    // reset the display cache

    let { selectedBuild } = this.state;

    if (selectedBuild) {
      this.projectMap[selectedBuild.id].selected = false;
      selectedBuild = null;
    }

    this.handleBuildCardExpand(item, callback);
  }

  handleSubHeaderExpand(expandAmount, animatorGroup, time) {
    if (animatorGroup) {
      const startHeight = window.innerHeight - this.state.scrollHeightDiffFromHeader;
      const endHeight = window.innerHeight - 18;
      const ani1 = this.animator.createPropertyAnimation('project-detail-scroller', time,
        { height: { startVal: startHeight, endVal: endHeight } });
      animatorGroup.push(ani1);
      const ani2 = this.animator.createPropertyAnimation('project-detail', time,
        { height: { startVal: startHeight, endVal: endHeight } });
      animatorGroup.push(ani2);
    }
    else {
      this.setState({ scrollHeightDiffFromHeader: expandAmount });
    }
  }

  handleProjectSelection(build, onComplete) {
    const { project } = this.state;

    this.props.history.push('/projects/' + project.id + '/build/all');
  }

  handleBuildSelection(build, project) {
    if (this.state.selectedBuild) {
      this.cachedSubFooter = null;
      this.setState({ selectedBuild: null });
      if (this.state.selectedBuild) {
        this.projectMap[this.state.selectedBuild.id].selected = false;
      }
    }
    this.props.history.push('/projects/' + project.id + '/build/' + build.id);
  }

  handleBulkAssignBuildSelection(build, alreadySelected) {
    if (this.bulkAssignBuilds) {
      //keep track of builds to save
      if (alreadySelected) {
        const foundBuildIndex = this.bulkAssignBuilds.findIndex(assignedBuild => assignedBuild.id == build.id);
        this.bulkAssignBuilds.splice(foundBuildIndex, 1);
        this.setState({ isAssignAllBuildsSelected: false });
      } else {
        this.bulkAssignBuilds.push(build);
      }

      //if all builds are selected, then this is true
      if (this.availableBuildsForBulkAssign && !this.state.isAssignAllBuildsSelected && (this.bulkAssignBuilds && this.bulkAssignBuilds.length == this.availableBuildsForBulkAssign.length)) {
        this.setState({ isAssignAllBuildsSelected: true });
      }

      this.setState({ bulkAssignBuildCount: this.bulkAssignBuilds ? this.bulkAssignBuilds.length : 0 }, () => {
        const projectChildrenDisplay = this.createExpandedProjectChildren(this.state.project);
        this.setState({ projectChildrenDisplay });
        //this.scroller.scrollTop = 0
      });
    }
  }

  handleBulkAssignSelectAll() {
    if (!this.state.isAssignAllBuildsSelected) {
      this.bulkAssignBuilds = [...this.availableBuildsForBulkAssign];
      this.setState({ isAssignAllBuildsSelected: true });
    }
    else {
      this.bulkAssignBuilds = [];
      this.setState({ isAssignAllBuildsSelected: false });
    }

    this.setState({ bulkAssignBuildCount: this.bulkAssignBuilds.length }, () => {
      const projectChildrenDisplay = this.createExpandedProjectChildren(this.state.project);
      this.setState({ projectChildrenDisplay });
      // this.scroller.scrollTop = 0
    });
  }

  async handleCreateBuild(build, parent) {
    const { project } = this.state;

    if (build.name) {
      if (!parent || !parent.id) {
        parent = { id: project.root_build_id, location_id: project.location ? project.location.id : null, builds: project.root_build.builds };
      }
      let order = 1;
      if (parent && parent.builds) {
        parent.builds.filter(build => {
          if (build.order >= order) {
            order = build.order + 1;
          }
          return true;
        });
      }
      const newBuild = {
        name: build.name,
        order: order,
        ancestry: (parent.ancestry ? parent.ancestry + '/' : '') + parent.id,
        location_id: build.location ? build.location.id : parent.location ? parent.location.id : null,
      };
      let createdBuild = await dataModel.buildsDAO.createBuild(newBuild, null, { recordDescriptor: build_card });
      if (createdBuild) {
        createdBuild.user_build_assignments = build.user_build_assignments;
        this.updateBuildAssignments(createdBuild, project, build.user_build_assignments);
      }
    }
    dataModel.dataChanged = false;
  }

  updateBuildAssignments(build, project, assignments) {
    for (let assignment of assignments) {
      const assignmentType = assignment.assignment_type;
      if (assignmentType == 'build_owner' || assignmentType == 'notify') {
        // these are the only 2 supported assignment types56
        if (assignment.toBeAdded) {
          delete assignment.toBeAdded;
          delete assignment.user.toBeAdded;
          dataModel.buildsDAO.addUserAssignment(build, project, assignment).then(() => {
            if (assignmentType == 'build_owner') {
              // log analytics event
              if(!this.currentRole) {
                this.currentRole = this.props.currentUser ? this.props.currentUser.role : null;
                this.analyticsLogger.setUserRole(this.currentRole);
              }
              const isExistingBuild = build.build_owners && build.build_owners.length ? true : false;
              this.analyticsLogger.logBuildOwnerUpdateEvent(isExistingBuild);
            }
          });
        }
        else if (assignment.toBeDeleted) {
          delete assignment.toBeDeleted;
          delete assignment.user.toBeDeleted;
          dataModel.buildsDAO.removeUserAssignment(build, assignment, false);
        }
      } 
    }
  }

  handleProjectWizardDone() {
    this.setState({ projectEdit: false });
  }

  handleWizardDone(parentOfBuildUpdated) {
    if (parentOfBuildUpdated) {
      this.parentOfBuildUpdated = parentOfBuildUpdated;
    }
    this.setState({ buildAdd: false, buildEdit: false });
  }

  handleProjectEdit(projeft) {
    this.setState({ projectEdit: true });
  }

  handleProjectTimeLineExpandContract(expanded) {
    if (expanded) {
      this.analyticsLogger.logProjectEvent('ProjectActivityExpanded');
      let heightDiff = 135; 
      let toHeight = window.innerHeight - (heightDiff + this.state.scrollHeightDiffFromHeader) - 260;
      this.setState({ internalprojectTimelineExpanded: true });
      anime({
        targets: '.project-card-scroller',
        height: toHeight,
        easing: 'easeInOutCubic',
        duration: 500,
        complete: () => {
          this.setState({ preprojectTimelineExpanded: true });
          this.setState({ internalprojectTimelineExpanded: true });
        },
      });
      anime({
        delay: 10,
        targets: '.project-event-chart',
        width: ((window.innerWidth - 250) * 0.95) + 20,
        easing: 'easeInOutCubic',
        duration: 500,
      });
      anime({
        delay: 10,
        targets: '.project-event-chart',
        height: 260,
        easing: 'easeInOutCubic',
        duration: 500,
        complete: () => {
          this.setState({ projectTimelineExpanded: true });
    
          let historyState = this.props.history.getState();
          if (!historyState) {
            historyState = {};
          }
          if (!historyState.projectHierachyState) {
            historyState.projectHierachyState = { projectTimelineState: {} };
          }
          historyState.projectHierachyState.projectTimelineState[this.state.project.id] = { expanded: true };
          this.props.history.setState(historyState);
        },
      });
    }
    else {
      let heightDiff = 135;
      let height = window.innerHeight - (heightDiff + this.state.scrollHeightDiffFromHeader) - 55;
      anime({
        targets: '.project-card-scroller',
        height: height,
        easing: 'easeInOutCubic',
        duration: 500,
        complete: () => {
          this.setState({ preprojectTimelineExpanded: false });
        },
      });
      anime({
        targets: '.project-event-chart',
        height: 65,
        easing: 'easeInOutCubic',
        duration: 500,
      });
      anime({
        targets: '.project-event-chart',
        width: 554,
        easing: 'easeInOutCubic',
        duration: 500,
        complete: () => {
          this.setState({ projectTimelineExpanded: false, internalprojectTimelineExpanded: false });
          let historyState = this.props.history.getState();
          if (!historyState) {
            historyState = {};
          }
          if (!historyState.projectHierachyState) {
            historyState.projectHierachyState = { projectTimelineState: {} };
          }
          historyState.projectHierachyState.projectTimelineState[this.state.project.id] = { expanded: false };
          this.props.history.setState(historyState);
        },
      });
    }
  }

  handleExpansion(height, type) {
    const expandedValue = height > 0;
    PageStateDAO.setPageStateEntry(PageNames.PROJECTS_CONTAINER, 'mapExpanded', expandedValue);
    this.setState({ displayHeight: height, mapExpanded: expandedValue });
    if (this.props.handleMapExpansion) {
      this.props.handleMapExpansion(expandedValue, type);
    }
    this.handleSubHeaderExpand(height);
  }

  async handleBulkAssignSave() {
    const builds = this.bulkAssignBuilds.map(build => build.id);
    const { quickAssignments } = this.props;
    let bulkAssignErrors = [];
    for (let key in quickAssignments) {
      if (key) {
        const assignmentType = key == 'build-notify' ? 'notify' : key == 'build-owner' ? 'build_owner' : key;
        for (let userId in quickAssignments[key]) {
          if (userId) {
            let user = quickAssignments[key][userId];
            const requestData = { user_id: user.id, assignment_type: assignmentType, builds: [] };
            for (let build_id of builds) {
              requestData.builds.push(build_id);
            }
            const userErrors = await dataModel.buildsDAO.bulkAssign(requestData);
            if (userErrors) {
              userErrors.forEach(ue => {
                if (!bulkAssignErrors.find(bae => { return bae.id == ue.id; })) {
                  bulkAssignErrors.push(ue);
                }
              });
            }
          }
        }
      }
    }
    dataModel.usersDAO.quickAssignments = null; 
    this.props.history.push('/projects/' + this.state.project.id);

    if (bulkAssignErrors.length) {
      this.setState({ bulkAssignErrors });
    }
  }

  handleCloseQuickerAssignError() {
    this.setState({ bulkAssignErrors: null });
  }

  handleBulkAssignCancel() {
    dataModel.usersDAO.quickAssignments = null;
    this.props.history.push('/projects/' + this.state.project.id);
  }

  handleClosedDelay() {
    this.setState({ displayDelayId: null });
  }

  handleEventClickThrough(event) {
    this.analyticsLogger.logProjectEvent('ProjectActivityDrilldown');
    if (event.eventable_type == 'Task') {
      dataModel.tasksDAO.getTask(event.eventable_id).then(task => {
        this.props.history.push(`/projects/${task.project_id}/build/${task.build_id}/task/${task.id}`);
      });
    }
    else if (event.eventable_type == 'CompletionCriterion') {
      dataModel.completionCriteriaDAO.getCompletionCriterion(event.eventable_id).then(completionStep => {
        dataModel.tasksDAO.getTask(completionStep.task_id).then(task => {
          this.props.history.push(`/projects/${task.project_id}/build/${task.build_id}/task/${task.id}`);
        });
  
      });
    }
    else if (event.eventable_type == 'Project') {
    }
    else if (event.eventable_type == 'Delay') {
      this.setState({ displayDelayId: event.eventable_id });
    }
  }

  handleDisplayQuickerAssign(project, isVendorBuildOwner, quickAssignUser) {
    this.setState({ displayQuickerAssignPopup: project, isVendorBuildOwner, quickAssignUser });
  }

  handleCloseQuickerAssign() {
    this.setState({ displayQuickerAssignPopup: null });
  }

  render() {

    if (!this.props.permissions.canViewProject && !this.props.permissions.canViewProjectLimited) {
      this.props.history.push({ pathname: '/' });
    }

    let { project } = this.state;

    const { scrollHeightDiffFromHeader } = this.state;

    if (project && !project.location) {
      project.location = { address: '', city: '', state: '', zip: '' };
    }

    //***************************************************
    // Handle props changes    
    //***************************************************    

    //***************************************************
    // Handle state changes
    //***************************************************    
    let heightDiff = 135;
    let projectDetailScrollStyle = {
      height: window.innerHeight -
        (heightDiff + scrollHeightDiffFromHeader),
      marginTop: this.state.displayHeight,
    };
    let scrollStyle = {
      height: window.innerHeight -
        (heightDiff + scrollHeightDiffFromHeader) - (!this.props.quickAssignments ? (this.state.preprojectTimelineExpanded ? 260 : 55) : 0),
    };

    let timelineStyle = { height: this.state.projectTimelineExpanded ? 266 : 64 };

    //***************************************************
    // Render everything
    //***************************************************    

    let projectChildren = null;
    if (project) {
      this.resized = false;
      projectChildren = this.state.projectChildrenDisplay;
      if (projectChildren == -1 || this.state.projectNoChildren) {
        projectChildren = null;
      }
    }
    if (!this.hasAnimated) {
      this.hasAnimated = true;
    }

    const style = { height: this.containerHeight ? this.containerHeight : 0 + 45 };
    let pageHeader = null;

    pageHeader = <ProjectHeader
      currentCompany={this.props.currentCompany}
      // We have already fetched this project; hand it over so the header is not blank while its
      // own store-only read comes up empty on a cold store.
      project={project}
      projectId={+this.props.params.project_id}
      handleExpansion={this.handleExpansion}
      type='projects-page'
      mapExpanded={this.state.mapExpanded}
      mapType={this.props.mapType}
      permissions={this.props.permissions}
      inProjectsTab={true}
      updateProject={this.props.updateProject}
      displayDelayId={this.state.displayDelayId}
      closedDelay={this.handleClosedDelay}
      displayQuickerAssign={this.handleDisplayQuickerAssign}
      isLeftDividerHide={true}
    />;
    const documentsSection = (
      <ExpandableSection name="DOCUMENTS" documentsLength={project && project.reference_documents?project.reference_documents.length:0}
       projectDocuments={project &&  project.unique_documents?project.unique_documents.length:0} 
       additionClass={project && (project.projected_start_date || project.actual_start_date) ? 'has-dates' : ''}>
        {this.userCanModifyDocuments &&
          <MultiFileUploader
            backgroundIcon={<DocumentsIcon iconColor={styles.lightElement} />}
            handleFileSelect={this.uploadProjectDocument}
            hasInlineLoader={true}
          />
        }
        <DocumentsList
          documentType='reference'
          documents={project ? project.reference_documents : null}
          parentComponentView={'project'}
          canDeleteDocuments={this.userCanModifyDocuments}
          handleDeleteDocument={this.deleteReferenceDocument}
        />
        <DocumentsList
          documentType='project'
          documents={project ? project.unique_documents : null}
          canDeleteDocuments={this.userCanModifyDocuments}
          handleDeleteDocument={this.deleteProjectDocument}
          parentComponentView={'project'}
        />
      </ExpandableSection>
    );

    let quickerAssignContainer = null;
    if (this.state.displayQuickerAssignPopup) {
      quickerAssignContainer =
        (
        <Modal show={true}>
          <QuickerAssignPopup
            projectId={this.state.displayQuickerAssignPopup.id}
            handleClosePopup={this.handleCloseQuickerAssign}
            isVendorBuildOwner={this.state.isVendorBuildOwner}
            currentCompany={this.props.currentCompany}
            selectedUser={this.state.quickAssignUser}
            currentUser={this.props.currentUser}
          />
          </Modal>
        );
    }

    let quickerAssignErrorContainer = null;
    if (this.state.bulkAssignErrors) {
      quickerAssignErrorContainer =
        (
        <Modal show={true}>
          <QuickerAssignErrorPopup
            handleClosePopup={this.handleCloseQuickerAssignError}
            currentCompany={this.props.currentCompany}
            currentUser={this.props.currentUser}
            bulkAssignErrors={this.state.bulkAssignErrors}
            fromBuilds={true}
          />
          </Modal>
        );
    }

    const projectLoadError = this.state.projectLoadError;
    const projectLoadPending = !projectLoadError && (this.state.projectLoadPending || (this.props.params.project_id && !project));
    let content;
    if (projectLoadError) {
      content = (
        <div id="project-detail" className="project-detail project-detail--error" style={projectDetailScrollStyle}
          ref={(element) => { this.outerScroll = element; }}>
          <div className="project-detail-not-found">
            <div className="project-detail-not-found__title">Project not found</div>
            <div className="project-detail-not-found__label">
              This project doesn&apos;t exist or you don&apos;t have access to it. Select a project from the list to continue.
            </div>
          </div>
        </div>
      );
    }
    else if (projectLoadPending) {
      content = (
        <div id="project-detail" className="project-detail project-detail--loading" style={projectDetailScrollStyle}
          ref={(element) => { this.outerScroll = element; }}>
          <div className="project-detail-loading">
            <LoadingDots />
            <div className="project-detail-loading__label">Loading project...</div>
          </div>
        </div>
      );
    }
    else if (this.props.quickAssignments) {
      content = (
        <div id="project-detail" className="project-detail" style={projectDetailScrollStyle}
          ref={(element) => { this.outerScroll = element; }}>
          <div className='bulk-assign-overlay'>
          <AssignmentPullout 
            quickAssignments={this.props.quickAssignments}
            selectedCount={this.state.bulkAssignBuildCount}
            handleSave={this.handleBulkAssignSave}
            handleCancel={this.handleBulkAssignCancel}
          />
          <div id="project-detail-scroller" className="project-card-scroller" style={scrollStyle}
            ref={(element) => { this.scroller = element; }}>
            <div className="project-and-build-card-container" id="project-and-build-card-container" style={style} ref={(element) => { this.container = element; }}>
                <div className='ba-project-info-container-overlay' onClick={(e) => { e.stopPropagation();}}></div>                
                <div className='ba-project-info-container'>
                <DashboardProjectCard
                  project={project}
                  left={0}
                  top={32}
                  width={256}
                  height={'auto'}
                  handleCardClick={this.handleProjectSelection}
                  displayDocuments={true}
                />
                {this.state.userCanViewDocuments && documentsSection}
                </div>
                <div className="select-all">
                  <CheckBox
                    key={'build-owner-checkbox'}
                    toggleCheckBox={this.handleBulkAssignSelectAll}
                    small={true} inversed={true}
                    checked={this.state.isAssignAllBuildsSelected}
                  />
                  <div className="select-all-caption">Select All</div>
                </div>
                {projectChildren}
              </div>
            </div>
          </div>
        </div>
      );
    }
    else {
      content = (
        <div id="project-detail" className="project-detail" style={projectDetailScrollStyle}
          ref={(element) => { this.outerScroll = element; }}>
          <div id="project-detail-scroller" className="project-card-scroller" style={scrollStyle}
            ref={(element) => { this.scroller = element; }}>
            <div className="project-and-build-card-container" id="project-and-build-card-container" style={style} ref={(element) => { this.container = element; }}>
              <DashboardProjectCard 
                project={project}
                left={0}
                top={32}
                width={256}
                height={'auto'}
                handleCardClick={this.handleProjectSelection}
                displayDocuments={true}
              />
              {this.state.userCanViewDocuments && documentsSection}
              {projectChildren}
            </div>
          </div>
            <div id="project-event-chart" className={'project-event-chart' + (this.state.projectTimelineExpanded ? ' expanded' : '')}
              style={timelineStyle}>
              <ProjectTimeline key={+this.props.params.project_id} project_id={+this.props.params.project_id}
                expandContract={this.handleProjectTimeLineExpandContract} expanded={this.state.internalprojectTimelineExpanded}
                handleEventClickThrough={this.handleEventClickThrough}
              />
            </div>
        </div>
      );
    }
    
    return (
      <div className={'project-hierarchy ' + (this.props.wontAnimate ? 'wontAnimate' : '')} id={this.props.id} >
        {quickerAssignContainer}
        {quickerAssignErrorContainer}
        {pageHeader}
        {content}
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    quickAssignments: state.new_users.quickAssignments,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    needsLogin: state.main ? state.main.needsLogin : null,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectHierarchy));



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/index.js